<template>
  <div>
    <b-row>
      <b-col
        md="12"
        class="justify-content-center"
        :key="i"
        v-for="(kyc, i) in kycDocuments"
      >
        <b-row>
          <h5 class="h5-text p-2">
            {{ kyc.docType }} :
            <span class="span-text">{{ kyc.docuementNo }}</span>
          </h5>
        </b-row>
        <b-row>
          <h5 class="h5-text p-2">
            Document Type :
            <span class="span-text">{{ kyc.docType }}</span>
          </h5>
        </b-row>
        <b-row>
          <h5 class="h5-text p-2">Photo :</h5>
        </b-row>
        <b-row>
          <b-col md="6">
            <a target="_blank" :href="kyc.frontSideFilePath">
              <img :src="kyc.frontSideFilePath" class="border-img-doc" height="200px" width="300px" />
            </a>
            <label>Front Side</label>
          </b-col>
          <b-col md="6">
            <a target="_blank" :href="kyc.backSideFilePath">
              <img :src="kyc.backSideFilePath" class="border-img-doc" height="200px" width="300px" />
            </a>
            <label>Back Side</label>
          </b-col>
        </b-row>
        <hr />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    kycDocuments: {
      type: [Array, Object],
    },
  },
};
</script>
<style scoped>
  .border-img-doc {
    border: 2px solid black;
    border-radius: 5px;
  }
</style
